import React, { Component } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import { withRouter, Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

// users
import settingIcon from "../../../assets/img/setting-icon.png";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { connect } from "react-redux";
import { API_URL } from "helpers/api_url";
import { toast } from "react-toastify";

const getUserName = () => {
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj;
  }
}

class ProfileMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
      name: "Admin",
    }
    this.toggle = this.toggle.bind(this)
    this.toggleChangePass = this.toggleChangePass.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }

  componentDidMount() {
    const userData = getUserName();
    if (userData) {
      this.setState({ name: userData.username })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.success !== this.props.success) {
      const userData = getUserName();
      if (userData) {
        this.setState({ name: userData.username })
      }
    }
  }
toggleChangePass() {
    this.setState({ isChangePass: !this.state.isChangePass });
    
  }
 handleSubmit = async (values, { setSubmitting, resetForm }) => {
  toast.loading('Please wait...')
    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const payload = {
        userName: values.userName,
        password: values.newPassword,
        oldPassword: values.oldPassword,
      };
      const response = await axios.post(
        `${API_URL}user/changepassword`,
        payload,
        { headers }
      );
       if (response.data.success) {
          toast.dismiss();
           toast.success("Password changed successfully!");
           this.toggleChangePass();
            resetForm();
      }else{
         toast.dismiss();
           toast.warn(response.data.validationErrors[0] || "Failed to change password");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.message || "Failed to change password"
      );
    } finally {
      setSubmitting(false);
    }
  };
  render() {
    const { userdetail, clientDetail } = this.props;
    
    const UserAvatarText = ({ firstName, lastName }) => {
  const initials =
    (firstName?.charAt(0) || "").toUpperCase() +
    (lastName?.charAt(0) || "").toUpperCase();

  return (
    <div
      style={{
        backgroundColor: "#03002E",
        color: "#fff",
        borderRadius: "50%",
        width: "36px",
        height: "36px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "16px",
      }}
    >
      {initials}
    </div>
  );
};
    return (
      <React.Fragment>
       <li className="d-inline-block d-flex align-items-center">
  <h4 className="ms-4 me-4 font-size-15 profile-name mb-0">
    {clientDetail?.firstName + " " + clientDetail?.lastName}
    <span className="text-muted"> Client Portal</span>
  </h4>
</li>
 <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="d-inline-block"
        >
          <DropdownToggle
            className="btn header-item"
            id="page-header-user-dropdown"
            tag="button"
          >
            <img
              className="rounded-circle header-profile-user"
              src={settingIcon}
              alt="Header Avatar"
            />{" "}
            {/* <span className="d-none d-xl-inline-block ms-1">
              {this.state.name}
            </span> */}
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
            <DropdownItem tag="a" onClick={this.toggleChangePass}>
              <i className="bx bx-user font-size-16 align-middle ms-1" />
              {this.props.t("Change Password")}
            </DropdownItem>
          
            <div className="dropdown-divider" />
            <Link to="/logout" className="dropdown-item">
              <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
              <span>{this.props.t("Logout")}</span>
            </Link>
          </DropdownMenu>
        </Dropdown>
       <Offcanvas
            isOpen={this.state.isChangePass}
            direction="end"
            toggle={this.toggleChangePass}
            style={{ width: 600 }}
          >
            <OffcanvasHeader toggle={this.toggleChangePass}>
             Change Password
            </OffcanvasHeader>
              <OffcanvasBody>
                    <Formik
              initialValues={{
                    userName: clientDetail?.userLogin?.userName,
                    oldPassword: "",
                    newPassword: "",
                    confirmPassword: "",
              }}
         validationSchema={Yup.object().shape({
                  oldPassword: Yup.string().required("Old password is required"),
                  newPassword: Yup.string()
                    .min(6, "New password must be at least 6 characters")
                    .required("New password is required"),
                  confirmPassword: Yup.string()
                    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
                    .required("Confirm your new password"),
                })}
          onSubmit={this.handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="form-group mb-3">
                <label htmlFor="oldPassword">Old Password</label>
                <Field
                  type="password"
                  name="oldPassword"
                  className="form-control"
                />
                <ErrorMessage
                  name="oldPassword"
                  component="div"
                  className="text-danger"
                />
              </div>

              <div className="form-group mb-3">
                <label htmlFor="newPassword">New Password</label>
                <Field
                  type="password"
                  name="newPassword"
                  className="form-control"
                />
                <ErrorMessage
                  name="newPassword"
                  component="div"
                  className="text-danger"
                />
              </div>

              <div className="form-group mb-3">
                <label htmlFor="confirmPassword">Confirm New Password</label>
                <Field
                  type="password"
                  name="confirmPassword"
                  className="form-control"
                />
                <ErrorMessage
                  name="confirmPassword"
                  component="div"
                  className="text-danger"
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Changing..." : "Change Password"}
              </button>
            </Form>
          )}
        </Formik>
              </OffcanvasBody>
          </Offcanvas>
      </React.Fragment>
    )
  }
}

ProfileMenu.propTypes = {
  t: PropTypes.any,
  success: PropTypes.string,
  userdetail:PropTypes.object,
  clientDetail:PropTypes.object
}

const mapStateToProps = state => {
  
}

export default withRouter(
  connect()(withTranslation()(ProfileMenu))
)
